import cn from 'classnames';
import React from 'react';
import { Navigate } from 'react-router-dom';

import Container from '../../../Components/Container/Container';
import Users from './Sections/Users/Users';
import styles from './styles.module.scss';
import { useWindowSize } from '@brands/hooks';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';

const CollectorUsersPage = (): JSX.Element => {
  const screenSize = useWindowSize();
  const { userInfo } = useAppSelector(selectAuth);

  if (userInfo?.role?.name !== UserRoleName.Collector) {
    const rolePrefix = userInfo?.role?.name ?? 'Collector';
    return <Navigate to={`/${rolePrefix}/dashboard`} replace />;
  }

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
      childrenStyle={{
        alignItems: 'flex-start',
        paddingTop: '2rem',
        width: '100%',
      }}
    >
      <div
        className={cn(styles.containerPf, styles.collectorDashboardBody)}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Users />
      </div>
    </Container>
  );
};

export default CollectorUsersPage;
